import useApi from "../api";
import { ImageType } from "../../types";
import { IUser, IShopPayload } from "./types";
import { IProfile } from "../../components/settings/types";

class UserService {
  public user(): Promise<IUser> {
    return useApi.get(`/user/details`);
  }

  // v2 card: {externalUrl, layout} where layout is the builder state
  // {background, contactSaver, sections:[...]} or null. ownerPreview marks
  // the builder's own fetch so the backend doesn't count it as a visit.
  public cardV2(shopUid: string, ownerPreview = false): Promise<any> {
    return useApi.get(`/card/v2/${shopUid}`, {
      headers: ownerPreview ? { "X-Owner-Preview": "1" } : undefined,
    });
  }

  // Persist the v2 builder layout (owner only).
  public saveCardV2(shopUid: string, layout: unknown): Promise<any> {
    return useApi.put(`/card/v2/${shopUid}`, layout);
  }

  public updateProfile(body: IProfile): Promise<any> {
    return useApi.put(`/user/self`, body);
  }

  // Uploads to Lightsail object storage via POST /file/upload and returns the
  // stored file's public URL (BaseFileDTO.url).
  public async uploadImage(imageFile: File, type?: ImageType): Promise<string> {
    const formData = new FormData();
    formData.append("file", imageFile);

    const url = `/file/upload?fileType=${type || ImageType.HOME_BANNER_IMAGE}`;

    const res: { url: string } = await useApi.post(url, formData);
    return res.url;
  }

  public updateShop(id: number, body: IShopPayload): Promise<IUser> {
    return useApi.patch(`/user/shop/${id}`, body);
  }

  public createShop(body: IShopPayload): Promise<IUser> {
    return useApi.put(`/user/shop`, body);
  }

  public removeShop(id: number): Promise<IUser> {
    return useApi.patch(`/user/shop/${id}?isRemove=true`);
  }
}

export default new UserService();
